export default __webpack_public_path__ + "static/media/spinner.4c0dabf6.gif";